import { useKorintUniqConfig } from 'korint-sdk/react';
import { useEffect } from 'react';

export function Favicon() {
  const { favicon } = useKorintUniqConfig();

  useEffect(() => {
    if (!favicon) return;

    let link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    // Allow png/ico/svg by not forcing type if unknown
    link.href = favicon;
  }, [favicon]);

  return null;
}
